<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <path d="M2.688 18A1.69 1.69 0 0 1 1 16.312V3.938c0-.93.757-1.687 1.688-1.687H4.5V.562a.563.563 0 0 1 1.125 0V2.25h6.75V.562a.563.563 0 0 1 1.125 0V2.25h1.813c.93 0 1.687.757 1.687 1.688v12.374A1.69 1.69 0 0 1 15.312 18H2.688ZM3 15.43c0 .31.25.57.56.57h10.88c.31 0 .56-.26.56-.57V8H3v7.43Z"
          fill="currentColor"/>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'Calendar',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 18 18',
    },
  },
};
</script>

<style scoped>
  
</style>